import type {NetWorthInvestmentSplitQuery} from '@transactions/graphql';

type InvestmentSplit = NetWorthInvestmentSplitQuery['netWorthInvestmentSplit'];

/** One line of the split: a part of the change, null when it can't be known. */
export type SplitLine = {key: string; label: string; cents: number | null};

/**
 * The window's change in net worth, by where it came from: what investments
 * did (from the server's split over exactly what net worth counts), and
 * everything else, the rest of the change (saving and spending, other
 * assets' values, and what investments did before their records began).
 */
export const netWorthSplitLines = (split: InvestmentSplit, change: number | null): SplitLine[] => [
  {key: 'realized', label: 'Realized', cents: split.realized ?? null},
  {key: 'unrealized', label: 'Unrealized', cents: split.unrealized ?? null},
  // Market change that can't be split between realized and unrealized,
  // and what the checks couldn't explain: shown only when there is some.
  ...(split.unclassified !== 0 ? [{key: 'unclassified', label: 'Unclassified', cents: split.unclassified ?? null}] : []),
  ...(split.residual !== 0 ? [{key: 'residual', label: 'Unexplained', cents: split.residual ?? null}] : []),
  {key: 'income', label: 'Income', cents: split.income ?? null},
  {key: 'fees', label: 'Fees', cents: split.fees == null ? null : -split.fees},
  {
    key: 'else',
    label: 'Everything else',
    cents: split.investments == null || change == null ? null : change - split.investments,
  },
];
